import * as commonUtils from '@/utils/commonUtils'
import * as convertUtils from '@/utils/convertUtils'

export default {
  install(app) {
    app.config.globalProperties.$commonUtils = {
      ...commonUtils,
    }
    app.config.globalProperties.$convertUtils = {
      ...convertUtils,
    }
  }
}